<template>
<v-layout>
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="red"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  
  <v-col offset-md="1" md="10">
    
    <v-tabs
      background-color="grey darken-4"
      color="red"
      class="elevation-2"
      dark
      grow
      :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
      :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
      :icons-and-text="icons"
      >
      
      <v-tab>
        Only missing
        <v-icon>fa-exclamation-triangle</v-icon>
      </v-tab>
      
      <v-tab>
        Full report
        <v-icon>fa-list</v-icon>
      </v-tab>
      
      <v-tab>
        Daily history
        <v-icon>fa-chart-area</v-icon>
      </v-tab>
      
      <v-tab>
        Heatmap
        <v-icon>fa-chart-bar</v-icon>
      </v-tab>

      <v-tab>
        Monthly report
        <v-icon>fa-calendar-day</v-icon>
      </v-tab>
      <!-- ---------------------------------------------------------------------------------------------------- -->
      <v-tab-item>
	<v-container grid-list-xl text-center>
          <v-layout wrap>
	    <v-flex md8>
	      
	      <v-card dark color="amber darken-4" class="elevation-10">
	        <v-card-text>
	          <span class="display-1 font-weight-medium">Deliveries state </span>
	          <span class="display-1 font-weight-thin">@ {{ report.reportDate }}</span>
	        </v-card-text>
	      </v-card>
	      
	    </v-flex>
	    
	    <v-flex md4>
	      
	      <v-date-picker
	        class="elevation-10"
	        style="margin: 0"
	        :reactive="reactive"
	        v-model="wantedReportDate"
	        color="amber darken-4"
	        ></v-date-picker>
	      
	    </v-flex>
	  </v-layout>
	</v-container>
	
	<v-card>
	  <v-card-title>
	    Only missing
	    <v-spacer></v-spacer>
	    <v-text-field
              v-model="search"
              append-icon="fa-search"
	      color="red"
              label="Search"
              single-line
              hide-details
	      ></v-text-field>
	  </v-card-title>
	  
	  
	  <v-container text-center v-if="errorState">
	    <v-card
	      max-width="500"
	      class="mx-auto"
	      color="red"
	      >
	      <v-card-text>
		<span class="display-1 font-weight-medium">No data for this date</span>
		<br/>
		<br/>
		<v-icon>fa-exclamation</v-icon>
	      </v-card-text>
	    </v-card>
	  </v-container>
	  
	  <v-data-table v-else
			:headers="headers"
			:items="reportsNotOk"
			:search="search"
			:disable-pagination="booltrue"
			:hide-default-footer="booltrue"
			>
	    <template v-slot:item.missing="{ item }">
	      <!-- <v-btn class="ma-2" color="red">{{ item.missing }}</v-btn> -->
	      <Indicator :expected="item.expected_files" :available="item.delivered_files"></Indicator>
	    </template>
	  </v-data-table>
	  
	</v-card>
      </v-tab-item>
      <!-- ---------------------------------------------------------------------------------------------------- -->
      <v-tab-item>
	<v-container grid-list-xl text-center>
          <v-layout wrap>
	    <v-flex md8>
	      
	      <v-card dark color="amber darken-4" class="elevation-10">
	        <v-card-text>
	          <span class="display-1 font-weight-medium">Deliveries state </span>
	          <span class="display-1 font-weight-thin">@ {{ report.reportDate }}</span>
	        </v-card-text>
	      </v-card>
	      
	    </v-flex>
	    
	    <v-flex md4>
	      
	      <v-date-picker
	        class="elevation-10"
	        style="margin: 0"
	        :reactive="reactive"
	        v-model="wantedReportDate"
	        color="amber darken-4"
	        ></v-date-picker>
	      
	    </v-flex>
	  </v-layout>
	</v-container>
	
	<v-card>
	  <v-card-title>
	    Only missing
	    <v-spacer></v-spacer>
	    <v-text-field
              v-model="search"
	      color="red"
              append-icon="fa-search"
              label="Search"
              single-line
              hide-details
	      ></v-text-field>
	  </v-card-title>
	  
	  
	  <v-container text-center v-if="errorState">
	    <v-card
	      max-width="500"
	      class="mx-auto"
	      color="red"
	      >
	      <v-card-text>
		<span class="display-1 font-weight-medium">No data for this date</span>
		<br/>
		<br/>
		<v-icon>fa-exclamation</v-icon>
	      </v-card-text>
	    </v-card>
	  </v-container>
	  
	  <v-data-table v-else
			:headers="headers"
			:items="reports"
			:search="search"
			:disable-pagination="booltrue"
			:hide-default-footer="booltrue"
			>
	    <template v-slot:item.missing="{ item }">
	      
	      <!-- <v-btn v-if="item.missing === 0" class="ma-2" outlined color="green">OK</v-btn> -->
	      <!-- <v-btn v-else class="ma-2" color="red">{{ item.missing }}</v-btn> -->
	      
	      <Indicator :expected="item.expected_files" :available="item.delivered_files"></Indicator>
	      
	    </template>
	  </v-data-table>
	</v-card>
      </v-tab-item>
      <!-- ---------------------------------------------------------------------------------------------------- -->
      <v-tab-item>
	<v-container grid-list-xl text-center>
          <v-layout wrap>
	    <v-flex md8>
	      
	      <v-card dark color="amber darken-4" class="elevation-10">
	        <v-card-text>
	          <span class="display-1 font-weight-medium">Deliveries state </span>
	          <span class="display-1 font-weight-thin">@ {{ report.reportDate }}</span>
	        </v-card-text>
	      </v-card>
	      
	    </v-flex>
	    
	    <v-flex md4>
	      
	      <v-date-picker
	        class="elevation-10"
	        style="margin: 0"
	        :reactive="reactive"
	        v-model="wantedReportDate"
	        color="amber darken-4"
	        ></v-date-picker>
	      
	    </v-flex>
	  </v-layout>
	</v-container>
	
	<DailyHistory :wantedreportdate="wantedReportDate"></DailyHistory>
      </v-tab-item>
      <!-- ---------------------------------------------------------------------------------------------------- -->
      <v-tab-item>
	<Heatmaps :wantedreportdate="wantedReportDate"></Heatmaps>
      </v-tab-item>

      <!-- ---------------------------------------------------------------------------------------------------- -->
      <v-tab-item>
	<MonthlyReport></MonthlyReport>
      </v-tab-item>
    </v-tabs>
    
  </v-col>
</v-layout>
</template>

<script>
import goTo from 'vuetify/es5/services/goto';

import Heatmaps from './Heatmaps.vue';
import DailyHistory from './DailyHistory.vue';
import Indicator from './Indicator.vue';
import MonthlyReport from './MonthlyReport.vue';

import { config } from '../config';


export default {
    components: {
        Heatmaps,
	DailyHistory,
	Indicator,
	MonthlyReport,
    },
    
    data: () => ({
	search: '',
	headers: [
            { text: 'Client', value: 'client' },
            { text: 'Product', value: 'product' },
            { text: 'Expected files', value: 'expected_files' },
            { text: 'Delivered files', value: 'delivered_files' },
            { text: 'MISSING', value: 'missing' },
	],
        reactive: true,
        loading: true,
	errorState: false,
	booltrue: true,
        fixedHeader: true,
        report: {},
	reports: [],
	reportsNotOk: [],
        wantedReportDate: new Date().toISOString().substr(0, 10),
        icons: true,
        centered: false,
        grow: false,
        vertical: false,
        prevIcon: false,
        nextIcon: false,
        right: false,
        tabs: 3,
    }),
    
    created() {
        this.loadData();
    },
    
    watch: {
        wantedReportDate() {
            this.loading = true;
            this.loadData();
        },
    },
    
    computed: {
    },
    
    methods: {
        loadData() {
            const url = `${config.baseUrl}deliveries?date=${this.wantedReportDate}`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
                this.report = res.data;
		this.reportsNotOk = this.report.report.filter(record => record.delivered_files !== record.expected_files);
		this.reports = this.report.report;
		
		this.reports.forEach(r => {
		    r.missing = r.expected_files - r.delivered_files;
		});
		this.errorState = false;
		this.loading = false;
		
            }).catch((err) => {
                console.log(err);
		this.errorState = true;
            });
        },
	
        jumpTo(hash) {
            goTo(document.getElementById(hash));
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
